<template>
    <div class="prize_page">
        <header-bar :name='"评委与奖品"'></header-bar>
        <div class="contentBox ">

            <div class="content link " style="background-color: #fff;">
                <div class="title">
                    大赛评委
                </div>
                <div class="topBox">
                    <div class="box">
                        <div class="name">
                            <span>廖</span>
                            <span>媛</span>
                        </div>
                        <div class="textBox">
                            <div class="text">中国日报网国际传播部创意主管</div>
                            <div class="text">中国日报网旗下留学中国海外社交媒体矩阵负责人</div>
                        </div>
                    </div>
                    <div class="box">
                        <div class="name">付晓光</div>
                        <div class="textBox">
                            <div class="text">中国传媒大学电视学院教授</div>
                            <div class="text">博士生导师</div>
                        </div>
                        
                    </div>
                </div>
            </div>

            <div class="content link">
                <div class="title title2">
                    VLOG 奖品设置
                </div>
                <div class="introduce">
                    <div class="text">
                        请各位参与“闪亮的青春”志愿者短视频与图片故事征集活动的老师登陆您的账号，凡是作品通过展示的老师均会获得电子证书，请您自行下载打印，获得相关奖项的老师，请您认真填写相关信息，会有工作人员与您进行联络！
                    </div>
                    <div class="text">如有咨询问题，请通过邮箱：zhengji@chineseplus.net；</div>
                    <div class="text"> QQ号码：2151697624 与工作人员联络。</div>
                </div>
                <div class="cardBoxList">
                    <div class="cardBox">
                        <img class="pic" src="../img/Vcard/c1000.jpg" alt="">
                        <div class="cardTitle">一等奖、网络人气奖</div>
                        <div class="text">当当V卡1000元</div>
                    </div>
                    <div class="cardBox">
                        <img class="pic" src="../img/Vcard/c500.jpg" alt="">
                        <div class="cardTitle">二等奖</div>
                        <div class="text">当当V卡500元</div>
                    </div>
                    <div class="cardBox">
                        <img class="pic" src="../img/Vcard/c200.jpg" alt="">
                        <div class="cardTitle">三等奖</div>
                        <div class="text">当当V卡200元</div>
                    </div>
                    <div class="cardBox">
                        <img class="pic" src="../img/Vcard/c100.jpg" alt="">
                        <div class="cardTitle">优秀奖</div>
                        <div class="text">当当V卡100元</div>
                    </div>

                </div>

            </div>

        </div>
    </div>
</template>
  
<script>
import headerBar from './common/headerBar'
import {mapGetters} from 'vuex'
export default {
    name: "prize_page",
    components: {
        headerBar
    },
    data: function () {
        return {};
    },
    computed: {
        ...mapGetters(['getUserInfo'])
    },
    methods: {
        // routerTo(path) {
        //     this.$router.push(path);
        // },
    },
};
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.prize_page {
    width: 100%;
    margin: 0 auto 0;
    text-align: center;
    font-size: 20px;
    text-align: left;

    .back {
        font-size: 0.36rem;
        color: #0b0b0b;
        font-weight: bold;
        cursor: pointer;

        img {
            vertical-align: middle;
            width: 0.26rem;
            margin-top: -0.1rem;
            margin-left: 0.45rem;
        }
    }

    .contentBox {
        width: 100%;
        margin: auto;
        padding-top: 1rem;
        background-color: #ededf6;

        .content {
            width: calc(100% - 0.9rem);
            // margin: auto;
            // background-color: #fff;
            padding: 0 0.45rem 0.6rem;
            box-sizing: border-box;
            margin: 0 0.45rem;
            text-align: center;
            margin-top: 1rem;

            .title {
                position: relative;
                top: -0.45rem;
                width: 40%;
                height: 0.9rem;
                line-height: 0.88rem;
                margin: auto;
                background-image: linear-gradient(0deg,
                        #746bef 0%,
                        #728bf9 100%);
                border-radius: 0.44rem;
                text-align: center;
                font-size: 0.58rem;
                color: #fff;
                font-weight: bold;

                &:before {
                    position: absolute;
                    left: -1.1rem;
                    top: 0.2rem;
                    content: '';
                    display: inline-block;
                    width: 0.8rem;
                    height: 0.8rem;
                    background-image: url(../img/left.png);
                    background-size: contain;
                    background-repeat: no-repeat;
                }

                &:after {
                    position: absolute;
                    right: -1.2rem;
                    top: 0.2rem;
                    content: '';
                    display: inline-block;
                    width: 0.8rem;
                    height: 0.8rem;
                    background-image: url(../img/right.png);
                    background-size: contain;
                    background-repeat: no-repeat;
                }
            }

            .title2 {
                width: 55%;
                margin-top: 2rem;
            }

            .topBox {
                display: flex;
                flex-direction: column;

                .box {
                    width: 100%;
                    display: flex;
                    margin-top: 0.5rem;

                    .name {
                        width: 20%;
                        font-size: 0.6rem;
                        margin-top: 5px;
                        font-weight: 700;
                        color: #0b2ab0;
                        text-align: left;
                        display: flex;
                        justify-content: space-around;
                    }
                    .textBox{
                        width: 80%;
                        margin-left: 0.2rem;
                        display: flex;
                        flex-direction: column;
                        .text {
                        font-size: 0.3rem;
                        line-height: 0.6rem;
                        color: #000;
                        text-align: left;
                        font-family: initial;
                    }
                    }

                    
                }
            }

            .introduce {
                width: 90%;
                margin:auto;
                margin-top: 0.5rem;
                text-align: initial;

                .text {
                    font-size: 0.3rem;
                    line-height: 0.6rem;
                    color: #000;
                    font-family: initial;

                }
            }

            .cardBoxList {
                width: 108%;
                margin-left: -4%;
                margin-top: 40px;
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                justify-content: start;

                .cardBox {
                    width: 50%;
                    display: flex;
                    flex-direction: column;
                    margin-bottom: 37px;

                    .pic {
                        width: 6rem;
                        height: 6rem;
                        margin: auto;
                        background-color: #fff;
                        // border-radius: 15px;
                    }

                    .cardTitle {
                        font-size: 0.6rem;
                        margin-top: 0.6rem;
                        color: #0b2ab0;
                        font-weight: 800;
                    }

                    .text {
                        margin-top: 0.5rem;
                        font-size: 0.5rem;
                        color: #000000;
                        font-weight: 700;
                    }

                }

            }

        }

    }


}
</style>
  